import '@f-fertighaus/layout/PageHeader/SSR/PageHeaderSSR'
import '@f/components/PageSharing'
import '@js/common/site-wide'
import '@f-fertighaus/widgets/FloatingBanner'

import React from 'react'
import { createRoot } from 'react-dom/client'

import OfficeMap from '@f-fertighaus/applications/OfficeMap'

export const DEFAULT_MAP_RANGES = {
  lat__range: '47,54',
  lon__range: '6,15'
}

void (function () {
  const OfficeMapPage = () => {
    const initialParams = {}
    let searchParams = window.location.search
    if (searchParams) {
      searchParams = searchParams.replace('?', '')
      searchParams = searchParams.split('&')

      searchParams.map(paramSet => {
        let paramSetArray = paramSet.split('=')
        initialParams[paramSetArray[0]] = paramSetArray[1]
      })
    }

    if (!initialParams.lat__range || !initialParams.lon__range) {
      initialParams.lat__range = DEFAULT_MAP_RANGES.lat__range
      initialParams.lon__range = DEFAULT_MAP_RANGES.lon__range
    }
    return (
      <OfficeMap initialParams={initialParams} vendors={window.vendors || []} />
    )
  }

  const mountPoint = document.querySelector('#OfficeMapPage')

  if (mountPoint) {
    const root = createRoot(mountPoint)
    root.render(<OfficeMapPage pagetype={mountPoint.dataset.pagetype} />)
  }
})()
